export function formatImageUrl(url: string | undefined | null): string {
  if (!url) return '';
  if (url.startsWith('data:') || url.startsWith('blob:')) return url;

  const apiBase = (import.meta.env.VITE_BACKEND_URL ?? '').replace(/\/$/, '');
  const proxyImage = (key: string) => {
    const cleanKey = key.replace(/^\/+/, '');
    return apiBase && cleanKey ? `${apiBase}/api/app/images/${cleanKey}` : '';
  };

  if (url.startsWith('s3://')) {
    const withoutScheme = url.slice(5);
    const slashIndex = withoutScheme.indexOf('/');
    if (slashIndex === -1) return '';

    return proxyImage(withoutScheme.slice(slashIndex + 1));
  }

  if (url.includes('127.0.0.1') || url.includes('localhost') || url.includes('minio')) {
    try {
      const urlObj = new URL(url);
      const pathParts = urlObj.pathname.split('/').filter(Boolean);
      if (pathParts.length >= 2) return proxyImage(pathParts.slice(1).join('/'));
    } catch {
      return '';
    }
  }

  if (!url.startsWith('http')) {
    return proxyImage(url);
  }

  return url;
}
